import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faEnvelope, faLock } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Card, Form, Button, Container, InputGroup, Alert } from '@themesberg/react-bootstrap';
import { jwtDecode } from 'jwt-decode';

// Layout components
import Sidebar from '../../components/Sidebar';
import Navbar from '../../components/Navbar';

export default () => {
    const [userData, setUserData] = useState({ id: '', nome: '', email: '' });
    const [passwordData, setPasswordData] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [originalEmail, setOriginalEmail] = useState('');

    // Em vez de hardcodar o URL:
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    // Usa concatenação simples:


    const token = localStorage.getItem("token") || sessionStorage.getItem("token");

    useEffect(() => {
        if (token) {
            try {
                const decodedToken = jwtDecode(token);
                // No teu token, a chave é "id" e não "userId"
                const userId = decodedToken.id;

                if (userId) {
                    fetchUserData(userId);
                }
            } catch (err) {
                console.error("Erro ao decodificar token", err);
            }
        }
    }, [token]);

    const fetchUserData = async (id) => {
        const URL_UTILIZADORES_ID= `${API_BASE_URL}/Utilizadores/${id}`;

        try {
            const response = await fetch(URL_UTILIZADORES_ID, {
                headers: { "Authorization": `Bearer ${token}` }
            });
            if (response.ok) {
                const data = await response.json();
                setUserData({ id: data.id, nome: data.nome, email: data.email });
            }
        } catch (err) {
            setErrorMessage("Erro ao carregar dados do servidor.");
        }
    };

    const handleProfileUpdate = async (e) => {
        e.preventDefault();
        setErrorMessage('');
        setSuccessMessage('');

        const token = localStorage.getItem("token") || sessionStorage.getItem("token");

        const URL_UTILIZADORES_udID= `${API_BASE_URL}/Utilizadores/${userData.id}`;

        try {
            const response = await fetch(URL_UTILIZADORES_udID, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    Id: parseInt(userData.id),
                    nome: userData.nome,
                    email: userData.email,
                    password: userData.password // Agora enviamos a password para validar!
                })
            });

            if (response.ok) {
                setSuccessMessage('Perfil atualizado com sucesso!');
                setUserData({...userData, password: ''}); // Limpa o campo da pass por segurança
            } else {
                const error = await response.text();
                setErrorMessage(error || 'Erro ao atualizar perfil.');
            }
        } catch (err) {
            setErrorMessage('Erro de ligação ao servidor.');
        }
    };

    const handlePasswordUpdate = async (e) => {
        e.preventDefault();
        setErrorMessage('');
        setSuccessMessage('');

        const URL_UTILIZADORES_udID_PASSWORD= `${API_BASE_URL}/Utilizadores/${userData.id}/password`;

        if (passwordData.newPassword !== passwordData.confirmPassword) {
            setErrorMessage('As novas passwords não coincidem.');
            return;
        }

        try {
            const payload = {
                currentPassword: passwordData.currentPassword.trim(),
                newPassword: passwordData.newPassword.trim()
            };

            // Debug no console do browser para veres exatamente o que sai do React
            console.log("Enviando para o servidor:", payload);

            const response = await fetch(URL_UTILIZADORES_udID_PASSWORD, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                setSuccessMessage('Password alterada com sucesso!');
                setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
            } else {
                const errorText = await response.text();
                setErrorMessage(errorText || 'Erro ao validar password.');
            }
        } catch (err) {
            setErrorMessage('Erro de ligação ao servidor.');
        }
    };

    return (
        <>
            <Sidebar />
            <main className="content">

                {/* Container fluid para encostar à esquerda e py-4 para reduzir o topo */}
                <Container fluid className="px-4 py-4">

                    {/* Cabeçalho alinhado à esquerda */}
                    <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                        <div>
                            <h1 className="font-anton">Configurações de Perfil</h1>
                            <p className="font-open-sans text-muted">Gerencie as suas informações pessoais e de segurança da conta.</p>
                        </div>
                    </div>

                    {/* Mensagens de Feedback alinhadas à esquerda */}
                    <Row>
                        <Col xs={12} xl={10}>
                            {successMessage && <Alert variant="success" className="shadow-sm border-0">{successMessage}</Alert>}
                            {errorMessage && <Alert variant="danger" className="shadow-sm border-0">{errorMessage}</Alert>}
                        </Col>
                    </Row>

                    {/* Removemos o justify-content-center e usamos xl={5} ou xl={6} */}
                    <Row className="g-4">
                        {/* Bloco: Dados Pessoais */}
                        <Col xs={12} xl={5}>
                            <Card border="0" className="shadow-sm h-100">
                                <Card.Header className="bg-primary text-white py-3">
                                    <h5 className="mb-0 fw-bold font-anton">
                                        <FontAwesomeIcon icon={faUser} className="me-2" /> Dados Pessoais
                                    </h5>
                                </Card.Header>
                                <Card.Body className="p-4">
                                    <Form onSubmit={handleProfileUpdate}>
                                        <Form.Group className="mb-4">
                                            <Form.Label className="fw-bold font-montserrat">Confirmar Password</Form.Label>
                                            <InputGroup className="input-group-merge">
                                                <InputGroup.Text className="bg-light border-end-0">
                                                    <FontAwesomeIcon icon={faLock} className="text-muted" />
                                                </InputGroup.Text>
                                                <Form.Control
                                                    type="password"
                                                    className="bg-light border-start-0"
                                                    placeholder="Sua password atual..."
                                                    value={userData.password || ''}
                                                    onChange={e => setUserData({...userData, password: e.target.value})}
                                                    required
                                                />
                                            </InputGroup>
                                        </Form.Group>

                                        <hr className="my-4 text-gray-300" />

                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-bold">Nome Completo</Form.Label>
                                            <InputGroup>
                                                <InputGroup.Text><FontAwesomeIcon icon={faUser} /></InputGroup.Text>
                                                <Form.Control
                                                    type="text"
                                                    value={userData.nome}
                                                    onChange={e => setUserData({ ...userData, nome: e.target.value })}
                                                    required
                                                />
                                            </InputGroup>
                                        </Form.Group>

                                        <Form.Group className="mb-4">
                                            <Form.Label className="fw-bold">Email Associado</Form.Label>
                                            <InputGroup>
                                                <InputGroup.Text><FontAwesomeIcon icon={faEnvelope} /></InputGroup.Text>
                                                <Form.Control
                                                    type="email"
                                                    value={userData.email}
                                                    onChange={e => setUserData({ ...userData, email: e.target.value })}
                                                    required
                                                />
                                            </InputGroup>
                                        </Form.Group>

                                        <Button variant="primary" type="submit" className="w-100 shadow-soft py-2 fw-bold font-montserrat">
                                            Atualizar Dados
                                        </Button>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Bloco: Segurança */}
                        <Col xs={12} xl={5}>
                            <Card border="0" className="shadow-sm h-100">
                                <Card.Header className="bg-dark text-white py-3">
                                    <h5 className="mb-0 fw-bold font-anton">
                                        <FontAwesomeIcon icon={faLock} className="me-2" /> Segurança
                                    </h5>
                                </Card.Header>
                                <Card.Body className="p-4">
                                    <Form onSubmit={handlePasswordUpdate}>
                                        <Form.Group className="mb-4">
                                            <Form.Label className="fw-bold font-montserrat">Password Atual</Form.Label>
                                            <InputGroup>
                                                <InputGroup.Text className="bg-light border-end-0">
                                                    <FontAwesomeIcon icon={faLock} className="text-muted" />
                                                </InputGroup.Text>
                                                <Form.Control
                                                    type="password"
                                                    className="bg-light border-start-0"
                                                    placeholder="Confirme a atual..."
                                                    value={passwordData.currentPassword || ''}
                                                    onChange={e => setPasswordData({...passwordData, currentPassword: e.target.value})}
                                                    required
                                                />
                                            </InputGroup>
                                        </Form.Group>

                                        <hr className="my-4 text-gray-300" />

                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-bold">Nova Password</Form.Label>
                                            <InputGroup>
                                                <InputGroup.Text><FontAwesomeIcon icon={faLock} /></InputGroup.Text>
                                                <Form.Control
                                                    type="password"
                                                    placeholder="Mínimo 6 caracteres..."
                                                    value={passwordData.newPassword}
                                                    onChange={e => setPasswordData({ ...passwordData, newPassword: e.target.value })}
                                                    required
                                                />
                                            </InputGroup>
                                        </Form.Group>

                                        <Form.Group className="mb-4">
                                            <Form.Label className="fw-bold">Confirmar Nova Password</Form.Label>
                                            <InputGroup>
                                                <InputGroup.Text><FontAwesomeIcon icon={faLock} /></InputGroup.Text>
                                                <Form.Control
                                                    type="password"
                                                    placeholder="Repetir nova password..."
                                                    value={passwordData.confirmPassword}
                                                    onChange={e => setPasswordData({ ...passwordData, confirmPassword: e.target.value })}
                                                    required
                                                />
                                            </InputGroup>
                                        </Form.Group>

                                        <Button variant="dark" type="submit" className="w-100 shadow-soft py-2 fw-bold font-montserrat">
                                            Alterar Password
                                        </Button>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </main>
        </>
    );
};